import { render } from "./MyLogo.vue?vue&type=template&id=d488cf68"
import script from "./MyLogo.vue?vue&type=script&lang=js"
export * from "./MyLogo.vue?vue&type=script&lang=js"

import "./MyLogo.vue?vue&type=style&index=0&id=d488cf68&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__